import { DebugInfo } from "./hooks/useDebugMode";

interface DebugOverlayProps {
  debugInfo: DebugInfo;
  recordingMode: "raw" | "processed";
  onToggleMode: () => void;
  onPlayLastRecording?: () => void;
  hasLastRecording: boolean;
  urlHasDebugParam?: boolean;
}

/**
 * Debug overlay component for RecorderPanel.
 * Shows debug information and recording mode toggle when ?debugAudio=1 is in URL.
 */
export function DebugOverlay({
  debugInfo,
  recordingMode,
  onToggleMode,
  onPlayLastRecording,
  hasLastRecording,
  urlHasDebugParam = false,
}: DebugOverlayProps) {
  return (
    <div className="rounded-2xl border border-yellow-500/30 bg-yellow-500/10 p-4 text-sm">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="font-semibold text-yellow-200">
          Audio Debug Mode {urlHasDebugParam ? "(URL param detected)" : "(State)"}
        </h3>
        <button
          onClick={onToggleMode}
          className="rounded px-3 py-1 text-xs font-medium transition bg-yellow-500/20 text-yellow-200 hover:bg-yellow-500/30"
        >
          Mode: {recordingMode.toUpperCase()}
        </button>
      </div>
      <div className="mb-2 space-y-1 text-xs text-yellow-200/80">
        <div>mimeType: {debugInfo.mimeType || "—"}</div>
        <div>sampleRate: {debugInfo.sampleRate ? `${debugInfo.sampleRate} Hz` : "—"}</div>
        <div>blob size: {debugInfo.blobSize ? `${(debugInfo.blobSize / 1024).toFixed(2)} KB` : "—"}</div>
        {debugInfo.duration && <div>duration: {debugInfo.duration.toFixed(2)}s</div>}
        <div className={debugInfo.maxAmplitude != null && debugInfo.maxAmplitude < 0.01 ? "text-red-400 font-semibold" : ""}>
          maxAmplitude: {debugInfo.maxAmplitude != null ? debugInfo.maxAmplitude.toFixed(6) : "—"}
          {debugInfo.maxAmplitude != null && debugInfo.maxAmplitude < 0.01 && " ⚠️ TOO QUIET"}
        </div>
      </div>
      {hasLastRecording && onPlayLastRecording && (
        <button
          onClick={onPlayLastRecording}
          className="mt-2 rounded px-3 py-1 text-xs font-medium transition bg-yellow-500/20 text-yellow-200 hover:bg-yellow-500/30"
        >
          Play last recording
        </button>
      )}
    </div>
  );
}
